import React from 'react';

const width = 30;
const height = 15;
const centerX = width / 2;
const centerY = height / 2;

export default function WaitingIndicator() {
	return (
		<div className='waiting-wrapper'>
			<svg className="waiting-indicator" width={width} height={height}>
				<circle className="circle-1" cx={centerX - 9} cy={centerY} r={2.5} fill={'#B2B2BF'} />
				<circle className="circle-2" cx={centerX} cy={centerY} r={2.5} fill={'#B2B2BF'} />
				<circle className="circle-3" cx={centerX + 9} cy={centerY} r={2.5} fill={'#B2B2BF'} />
			</svg>
		</div>
	);
}
